export default __webpack_public_path__ + "static/media/playbutton.2d841693.gif";